import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { Collection } from '@/api/types'

export function useCollections(opts?: { include_deleted?: boolean }) {
  return useQuery<Collection[]>({
    queryKey: ['collections', opts?.include_deleted ?? false],
    queryFn: () => apiClient.listCollections({ include_deleted: opts?.include_deleted }),
    // No staleTime: it also suppresses refetchOnMount, which is why an upload's
    // effect on collection counts used to survive navigation and only a browser
    // reload cleared it. Collection state changes on every ingest.
  })
}
